import Layout from '@modules/layout/components/layout';
import Permissions from '@security/permissions';

const ProgramSettingsPage = () =>
  import('@modules/subproperty-settings/program-settings/components/program-settings-page.vue');
const LocationFormPage = () =>
  import('@modules/location/components/location-form-page.vue');
const CategoryFormPage = () =>
  import('@modules/category/components/category-form-page.vue');

export default [
  {
    path: '',
    component: Layout,
    children: [
      {
        props: true,
        name: 'programSettings',
        path: '/subproperty/settings/program/:tabName?',
        component: ProgramSettingsPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
        },
      },
      {
        name: 'programSettingsLocationNew',
        path: '/subproperty/settings/program/location/new',
        component: LocationFormPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.locationCreate,
        },
      },
      {
        name: 'programSettingsLocationEdit',
        path: '/subproperty/settings/program/location/:id/edit',
        component: LocationFormPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.locationEdit,
        },
        props: true,
      },
      {
        name: 'programSettingsCategoryNew',
        path: '/subproperty/settings/program/category/new',
        component: CategoryFormPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.categoryCreate,
        },
      },
      {
        name: 'programSettingsCategoryEdit',
        path: '/subproperty/settings/program/category/:id/edit',
        component: CategoryFormPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.categoryEdit,
        },
        props: true,
      },
    ],
  },
];
